import { Instagram, MapPin, Mail, Phone } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-bgblue text-cocoa pt-24 pb-10 px-6 lg:px-10 scroll-mt-20" data-testid="footer">
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <p className="uppercase tracking-[0.3em] text-xs font-500 text-cocoa/50 mb-6">Contact us</p>
          <h2 className="font-heading font-600 tracking-tight leading-[0.95] text-5xl sm:text-7xl lg:text-[8rem] text-cocoa">
            odd scoops
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-4 gap-10 border-t border-cocoa/15 pt-12">
          <div className="md:col-span-2 max-w-sm">
            <p className="text-cocoa/70 leading-relaxed">
              Artisanal gelato, slow-churned in small batches with premium, natural
              ingredients. Born and made in Bengaluru.
            </p>
            <p className="mt-6 flex items-center gap-2 text-cocoa/80">
              <MapPin size={18} className="text-pistachio" />
              Bengaluru, India
            </p>
          </div>

          <div>
            <p className="uppercase tracking-[0.25em] text-xs text-cocoa/50 mb-4">Get in touch</p>
            <div className="flex flex-col gap-3">
              <a href="tel:+919945186858" data-testid="footer-phone" className="flex items-center gap-2 text-cocoa/80 hover:text-berry transition-colors">
                <Phone size={18} /> +91 99451 86858
              </a>
              <a href="mailto:oddscoopsicecreams@gmail.com" data-testid="footer-email" className="flex items-center gap-2 text-cocoa/80 hover:text-berry transition-colors break-all">
                <Mail size={18} /> oddscoopsicecreams@gmail.com
              </a>
            </div>
          </div>

          <div>
            <p className="uppercase tracking-[0.25em] text-xs text-cocoa/50 mb-4">Follow</p>
            <div className="flex flex-col gap-3">
              <a href="https://instagram.com/oddscoops.in" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 text-cocoa/80 hover:text-berry transition-colors">
                <Instagram size={18} /> @oddscoops.in
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cocoa/50">
          <p>© {new Date().getFullYear()} odd scoops. Churned with care in Bengaluru.</p>
          <p>No artificial colours · No shortcuts</p>
        </div>
      </div>
    </footer>
  );
}
